var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-picker",class:[
        _vm.pickerColor,
        _vm.pickerSize,
        { 'number-picker--disabled': _vm.disabled },
        { 'number-picker--has-value': _vm.hasValue },
        { 'number-picker--min-value': _vm.isMinValue },
        { 'number-picker--max-value': _vm.isMaxValue } ]},[_c('div',{staticClass:"number-picker__substract"},[_c('Icon',{attrs:{"icon-class":_vm.iconEnum.SubstractCircle},on:{"icon-click":_vm.substract}})],1),_c('div',{staticClass:"number-picker__value"},[_vm._v("  "+_vm._s(_vm.currentValue))]),_c('div',{staticClass:"number-picker__add"},[_c('Icon',{attrs:{"icon-class":_vm.iconEnum.AddCircle},on:{"icon-click":_vm.add}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }